export const SidebarActionTypes = {
  TOGGLE_SIDEBAR_HIDDEN: "TOGGLE_SIDEBAR_HIDDEN",
};
